const departments = {
    leader: '负责人',
    leaders: '部门负责人',
    led_departments: '负责的部门',
    edit_leaders: '设置负责人',
    add_leader: '添加',
    remove_leader: '移除',
    no_leaders: '未设置负责人',
    local: '本地设置',
    managed_members: '管理范围内成员',
    leader_scope_hint: '仅可管理负责部门及子部门的成员归属。',
    leader_permission_hint: '负责人可管理本部门及子部门的成员归属，不能修改组织角色或部门结构。',
    primary_synced: '主部门由飞书同步维护。',
    status_active: '在职',
    status_suspended: '已冻结',
    status_departed: '已离职',
    status_pending: '待激活',
    search: '搜索',
    previous_page: '上一页',
    next_page: '下一页',
    directory_title: '组织成员',
    member_name: '成员',
    search_members: '按姓名或用户名搜索',
    include_descendants: '包含子部门',
    no_members: '没有匹配的成员。',
    all_members: '全部成员',
    all_departments: '全部部门',
    edit_member: '编辑部门归属',
    add_child: '新建子部门',
    expand_department: '展开{{name}}',
    collapse_department: '收起{{name}}',
    title: '部门',
    description: '管理当前组织的部门及成员归属。',
    create: '新建部门',
    edit: '编辑部门',
    name: '部门名称',
    parent: '上级部门',
    root: '无上级部门',
    id: '部门 ID',
    members: '成员部门归属',
    member_id: '成员用户 ID',
    primary: '主部门',
    none: '未设置',
    assignments: '部门归属记录',
    no_assignments: '暂无部门归属记录。',
    assignment_hint: '分配本地部门，可设置一个主部门。通讯录同步的归属由来源维护。',
    empty: '暂无部门。',
    readonly: '你可以查看部门和自己的归属。如需变更，请联系组织管理员。',
    load_error: '加载失败，请重试。',
    mutation_error: '保存失败，请检查权限、成员归属及部门层级。',
    loading: '正在加载…',
    synced: '通讯录同步',
    choose: '搜索部门',
    organizations_title: '组织与部门',
    organizations_description: '选择组织，查看或管理其部门。',
    no_organizations: '你尚未加入组织，请联系组织管理员。',
    organization: '当前组织',
    choose_organization: '请选择组织',
    delete_title: '删除部门',
    delete_description: '确认删除“{{name}}”？请先移走该部门的成员和子部门。',
};
export default Object.freeze(departments);
